import moment from 'moment';
import i18next from 'i18next';

// При перезачислении в тот же сад у ребёнка несколько записей контингента
// с одинаковым serviceProviderId — различаем их периодом пребывания.
export const getDdoPeriodSuffix = (record, allRecords) => {
  const hasSameDdoTwice =
    allRecords.filter(r => r.serviceProviderId === record.serviceProviderId)
      .length > 1;
  if (!hasSameDdoTwice) return '';

  const enrolled = moment(record.enrolledDate).format('DD.MM.YYYY');
  if (record.expelledDate) {
    return ` (${enrolled} — ${moment(record.expelledDate).format('DD.MM.YYYY')})`;
  }
  return ` (${i18next.t('myReports_fromDate', { date: enrolled })})`;
};
